import React, { useState, useEffect } from 'react';
import { ToastList, ToastProps } from './toast.props';
import { ToastStyles } from '../../../styles/molecules/toast.styles';

export const ToastMolecule = (props: ToastProps) => {
  const classes = ToastStyles();
  let position = '';
  switch (props.position) {
    case 'Top-Right':
      position = classes.TopRight;
      break;

    case 'Top-Left':
      position = classes.TopLeft;
      break;

    case 'Bottom-Left':
      position = classes.BottomLeft;
      break;

    case 'Bottom-Right':
      position = classes.BottomRight;
      break;

    default: {
      position = classes.BottomRight;
      break;
    }
  }

  const [list, setList] = useState(props.toastList);
  useEffect(() => {
    setList(props.toastList);
  }, [props.toastList, list]);

  const deleteToast = (id: number) => {
    const index = list.findIndex((e) => e.id === id);
    const toastListItem = props.toastList.findIndex((e) => e.id === id);
    list.splice(index, 1);
    props.toastList.splice(toastListItem, 1);
    setList([...list]);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (props.autoDelete && props.toastList.length && list.length) {
        deleteToast(props.toastList[0].id);
      }
    }, props.autoDeleteTime);
    return () => {
      clearInterval(interval);
    };
  }, [props.toastList, props.autoDelete, props.autoDeleteTime, list]);

  return (
    <div
      data-cy="data-notification-toast"
      className={`fixed box-border ${position} z-50`}
    >
      {list.map((toast: ToastList, i: number) => (
        <div
          key={i}
          className={`relative duration-300 ease-in-out cursor-pointer overflow-hidden
         z-50 mb-4 p-5 w-72 rounded shadow opacity-90 hover:opacity-100 notification_${toast.icon}
          ${position} ${toast.bgColor}`}
        >
          <button
            onClick={() => deleteToast(toast.id)}
            className="text-xs relative float-right outline-none -top-3 -right-3 text-white font-bold"
          >
            X
          </button>
          <div className="float-left w-7 h-7 mr-4">
            <img
              className="w-7 h-auto"
              src={`/images/icons/toast/${toast.icon}.svg`}
            />
          </div>
          <div>
            <p className="title h-7 font-semibold text-white text-lg lg:text-xl mb-4">
              {toast.title}
            </p>
            <p className="description  text-sm font-medium  break-words -ml-1 text-white">
              {toast.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};
